var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#model_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.088 1.515a.25.25 0 0 0-.179 0L1.988 3.762 8 6.124l6.012-2.362-5.925-2.247ZM1.5 11.74c0 .103.066.197.163.234l5.587 2.119V7.44L1.5 5.184v6.556Zm7.25 2.353 5.588-2.119a.254.254 0 0 0 .162-.234V5.184L8.75 7.443v6.653-.003ZM7.378.115c.4-.153.84-.153 1.24 0l6.25 2.372A1.745 1.745 0 0 1 16 4.12v7.619c0 .728-.45 1.378-1.128 1.637l-6.25 2.372c-.4.153-.84.153-1.24 0l-6.25-2.372A1.752 1.752 0 0 1 0 11.74V4.12c0-.728.45-1.378 1.128-1.637L7.378.112v.003Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "model_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgModel);
export default ForwardRef;